import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrderOverviewSalesComponent } from './order-overview-sales/order-overview-sales.component';
import { OrderDetailsSalesComponent } from './order-details-sales/order-details-sales.component';

const routes: Routes = [
  {
    path: 'order-history-sales',
    component: OrderOverviewSalesComponent
  },
  {
    path: 'order-history-sales/:id',
    component: OrderDetailsSalesComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrderHistorySalesRoutingModule { }
